import { render, staticRenderFns } from "./Balloon.vue?vue&type=template&id=5e986868&scoped=true&"
import script from "./Balloon.vue?vue&type=script&lang=js&"
export * from "./Balloon.vue?vue&type=script&lang=js&"
import style0 from "./Balloon.vue?vue&type=style&index=0&id=5e986868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e986868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e986868')) {
      api.createRecord('5e986868', component.options)
    } else {
      api.reload('5e986868', component.options)
    }
    module.hot.accept("./Balloon.vue?vue&type=template&id=5e986868&scoped=true&", function () {
      api.rerender('5e986868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/Balloon.vue"
export default component.exports